import React from "react";
import { useTranslation } from "react-i18next";
import ThermalReceipt from "../../../../Components/GeneralComponents/ThermalReceipt";

const money = (value) => `${Number(value || 0).toFixed(0)} AFN`;

const Print = ({ appointment }) => {
  const { t } = useTranslation();
  const direction = localStorage.getItem("direction");

  return (
    <ThermalReceipt
      direction={direction}
      clinicName={t("print.turkishClinic")}
      phone={`${t("print.phone")}: ${t("print.phoneNumber")}`}
      address={t("print.address")}
      rows={[
        {
          label: `${t("print.patient")}:`,
          value: `${appointment?.patient_name_display || ""} ${appointment?.patient_lastname_display || ""}`.trim() || "-",
        },
        { label: `${t("print.doctor")}:`, value: appointment?.doctor_name_display || "-" },
        { label: `${t("print.inLine")}:`, value: appointment?.appointments_before ?? "-" },
      ]}
      totals={[{ label: t("print.fees"), value: money(appointment?.fees), bold: true }]}
      footerLines={[t("print.thankYou"), t("print.getWellSoon"), t("print.poweredBy")]}
    />
  );
};

export default Print;
